import React, { FC } from 'react';

import Opinion from '@/components/Opinion';
import { StepUI } from '@/components/ui/ProgressBar';
import { RESPONSIVE_QUERY } from '@/consts';
import cn from '@/utils/cn';

import { Indicator, Progress } from '@radix-ui/react-progress';
import { useMediaQuery } from 'react-responsive';

export interface StepFinished {
  label: string;
  checked: boolean;
  unChecked?: boolean;
  active: boolean;
  progressFromProps?: number;
}

interface Props {
  className?: string;
  steps: StepFinished[];
  withProgress?: boolean;
  progressFromProps?: number;
}

const ProgressBarFinished: FC<Props> = ({
  steps,
  className,
  withProgress,
  progressFromProps,
}) => {
  const isDesktop = useMediaQuery({
    query: RESPONSIVE_QUERY.IS_DESKTOP,
  });

  const activeSteps = steps.filter((step) => step.active);

  const mobileProgress = progressFromProps
    ? progressFromProps
    : activeSteps[activeSteps.length - 1]?.checked ||
        activeSteps[activeSteps.length - 1]?.unChecked
      ? 100
      : 0;

  return (
    <div
      className={cn(
        'flex flex-row items-center gap-2 rounded-lg bg-white px-4 py-3 lg:min-w-[290px] lg:flex-col lg:items-start lg:rounded-[10px] lg:border-t-[6px] lg:border-primary lg:px-2 lg:pb-2 lg:pt-0',
        'relative z-40',
        'shadow-progress lg:shadow-none',
        className
      )}
    >
      {!isDesktop && (
        <>
          <StepUI
            step={activeSteps.length}
            label={activeSteps[activeSteps.length - 1]?.label}
            checked={activeSteps[activeSteps.length - 1]?.checked}
            unchecked={activeSteps[activeSteps.length - 1]?.unChecked ?? false}
          />
          <Progress
            value={mobileProgress}
            className="relative h-1.5 w-full flex-1 overflow-hidden rounded-full bg-dark-gray-100 lg:hidden"
          >
            <Indicator
              className="absolute size-full rounded-full bg-primary transition-transform duration-300 ease-in-out"
              style={{ transform: `translateX(-${100 - mobileProgress}%)` }}
            />
          </Progress>
        </>
      )}
      {isDesktop && (
        <>
          <div
            className={cn('flex w-full flex-col gap-2 px-3 pb-2.5 pt-[18px]')}
          >
            {steps.map((step, idx) => {
              const progress = progressFromProps
                ? progressFromProps
                : step.checked
                  ? 100
                  : 0;
              return (
                <div className="contents" key={idx}>
                  <StepUI
                    step={idx + 1}
                    label={step.label}
                    checked={step.checked}
                    unchecked={step.unChecked ?? false}
                    unActive={!step.active}
                  />
                  {withProgress && idx < steps.length - 1 && (
                    <div
                      className={
                        step.active && !steps[idx + 1].active ? 'h-11' : 'h-6'
                      }
                    >
                      <Progress
                        value={progress}
                        className={cn(
                          'relative hidden h-0.5 flex-1 rotate-90 overflow-hidden rounded-full bg-dark-gray-100 lg:flex',
                          step.active && !steps[idx + 1].active
                            ? 'max-w-[44px] translate-x-[-11px] translate-y-[22px]'
                            : 'max-w-[24px] translate-y-[11px]'
                        )}
                      >
                        <Indicator
                          className="absolute size-full rounded-full bg-primary"
                          style={{
                            transform: `translateX(-${100 - progress}%)`,
                          }}
                        />
                      </Progress>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <Opinion />
        </>
      )}
    </div>
  );
};

export default ProgressBarFinished;
